import React, { memo } from 'react'
import tw, { TwStyle } from 'twin.macro'
import { Chip } from 'src/components/shared/Chip'
import type { ChipTone } from 'src/constants/payments-ops/types'

interface Props {
  label: string
  tone: ChipTone
  dataTestId?: string
}

// Each tone is its 200 tint behind its 500 text. `warning` (pending / waiting states) is a yellow
// tint with `warning-700` text — `yellow-500` on `yellow-200` is unreadable.
const toneCss: Record<ChipTone, TwStyle> = {
  success: tw`bg-success-200`,
  warning: tw`bg-yellow-200`,
  critical: tw`bg-critical-200`,
  neutral: tw`bg-shades-100`,
}

const toneTextCss: Record<ChipTone, TwStyle> = {
  success: tw`text-success-500`,
  warning: tw`text-warning-700`,
  critical: tw`text-critical-500`,
  neutral: tw`text-shades-500`,
}

/** The shared `Chip` with a tone — one place for every Payments Ops status colour. */
const StatusChipComponent = ({ label, tone, dataTestId }: Props) => {
  return (
    <Chip
      text={label}
      className={toneCss[tone]}
      textClassName={[tw`whitespace-nowrap`, toneTextCss[tone]]}
      dataTestId={dataTestId}
    />
  )
}

export const StatusChip = memo(StatusChipComponent)
